export const cards = [
  "Play video games", 
  "Daily yoga",
  "Workout",
  "Spend time with family",
  "Listen music",
  "Sleep longer", 
  "Eat at home",
  "Meditation",
  "Read a book", 
  "Watch movies", 
  "Watch podcast", 
  "Learning new language", 
  "Work in pijama", 
  "Travel", 
  "Work from coffee shop", 
  "Work at night", 
  "Go for walk", 
  "Online conference",
  "Run every morning",
  "Do the laundary",
  "Lunch with friends", 
  "Online shopping", 
  "Spend time with friends", 
  "Walk with dog", 
  "Not losing time traveling",
  "Sleep during the day", 
  "Dress casually", 
  "Prepare breakfast",
  "Work from village",
  "Visit family",
  "Lunch with parents", 
  "Read blogs", 
  "Working from balcony", 
  "Flexible worktime", 
  "Daytime sauna"
  
];

export const combination = [
  [0,1,2,3,4],
  [5,6,7,8,9],
  [10,11,12,13,14],
  [15,16,17,18,19],
  [20,21,22,23,24],
  [0, 6, 12, 18, 24],
  [4, 8, 12, 16, 20],
  [0, 5, 10, 15, 20],
  [1, 6, 11, 16, 21],
  [2, 7, 12, 17, 22],
  [3, 8, 13, 18, 23],
  [4, 9, 14, 19, 24]
]

